import React, { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function HealthBadge() {
  const [state, setState] = useState({ status: "checking", db: "?" });

  useEffect(() => {
    let cancelled = false;
    const ping = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/health`, { timeout: 6000 });
        if (!cancelled) setState({ status: data.status, db: data.db });
      } catch {
        if (!cancelled) setState({ status: "down", db: "down" });
      }
    };
    ping();
    const id = setInterval(ping, 30000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  const ok = state.status === "ok";
  return (
    <div
      data-testid="health-badge"
      className="inline-flex items-center gap-2 rounded-full border border-zinc-800 bg-zinc-900/50 px-3 py-1 font-mono text-xs text-zinc-400"
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${ok ? "bg-emerald-400" : "bg-rose-500"}`}
        aria-hidden
      />
      api {state.status} · db {state.db}
    </div>
  );
}
